'use client';

import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useConfirmation, type ConfirmationConfig } from './use-confirmation';
import { ConfirmationDialog } from './confirmation-dialog';

let globalConfirm: ((cfg: ConfirmationConfig) => Promise<boolean>) | null = null;

export function setGlobalConfirm(fn: (cfg: ConfirmationConfig) => Promise<boolean>) {
  globalConfirm = fn;
}

export async function confirmGlobal(cfg: ConfirmationConfig): Promise<boolean> {
  if (!globalConfirm) {
    return true;
  }
  return globalConfirm(cfg);
}

if (typeof window !== 'undefined' && process.env['NODE_ENV'] !== 'production') {
  (
    window as unknown as {
      __kontoraConfirmGlobal?: (cfg: ConfirmationConfig) => Promise<boolean>;
    }
  ).__kontoraConfirmGlobal = confirmGlobal;
}

export function GlobalConfirmationProvider({ children }: { children: ReactNode }) {
  const { isOpen, config, confirm, onConfirm, onCancel } = useConfirmation();

  useEffect(() => {
    setGlobalConfirm(confirm);
    return () => {
      setGlobalConfirm(() => Promise.resolve(true));
    };
  }, [confirm]);

  return (
    <>
      {children}
      {config ? (
        <ConfirmationDialog
          isOpen={isOpen}
          title={config.title}
          description={config.description}
          confirmLabel={config.confirmLabel}
          cancelLabel={config.cancelLabel}
          variant={config.variant}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      ) : null}
    </>
  );
}